// Module
var code = `<div class="flex min-vh-100" id="onboarding-sidebar-wrapper"> <bds-loading-spinner size="small" color="main"></bds-loading-spinner> <onboarding-mfe class="flex" settings="{{\$ctrl.settingsSource}}" language="{{\$ctrl.language}}" user="{{\$ctrl.user}}" wsparams="{{\$ctrl.webSocketParams}}"> </onboarding-mfe> </div> `;
// Exports
module.exports = code;